import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import spaceNeedle from "./Space Needle.jpg";
import { useAuth } from "./App";

// Games flagged adminOnly show as a teaser to everyone except the platform admin,
// so in-development games can be tested live without opening them up.
const ADMIN_UID = "fy1HRZav9TW5MJFxHE1hc3mJFUl2";

const GAMES = [
  {
    id: "wc-pool",
    route: "/wc-pool",
    emoji: "⚽",
    name: "World Cup Pool",
    tagline: "2026 FIFA World Cup",
    description: "Pick group stage results, track knockouts, and battle friends across the full tournament.",
    accent: "#FFD700",
    accentDim: "rgba(255,215,0,0.12)",
    status: "COMPLETE",
    statusColor: "#8892a4",
    detail: "104 matches · 48 nations · One champion",
  },
  {
    id: "underdog-edge",
    route: "/underdog-edge",
    emoji: "🏈",
    name: "Underdog Edge",
    tagline: "2026 NFL Season Pool",
    description: "Pick one underdog per week all season long. Earn points equal to the closing spread when your dog pulls the upset.",
    accent: "#FF6B35",
    accentDim: "rgba(255,107,53,0.12)",
    status: "SEASON STARTS SEP 2026",
    statusColor: "#FF6B35",
    detail: "18 weeks · Outright upsets only · Season-long glory",
  },
  {
    id: "franchise-player",
    route: "/franchise-player",
    emoji: "🎖️",
    name: "Franchise Player",
    tagline: "One Franchise Player + Weekly Salary Cap",
    description: "Buy one franchise player for the whole season. He scores 1.25x every week. Then build the rest of your lineup each week under a $50K FanDuel salary cap. Most total points wins.",
    accent: "#14B8A6",
    accentDim: "rgba(20,184,166,0.12)",
    status: "IN DEVELOPMENT",
    statusColor: "#14B8A6",
    detail: "1 franchise player · 9-spot lineup with D/ST · Total points pool",
    adminOnly: true,
  },
  {
    id: "wwc-2027",
    route: null,
    emoji: "⚽",
    name: "Women's World Cup",
    tagline: "2027 FIFA Women's World Cup",
    description: "Pick group stage results, track knockouts, and battle friends across the full tournament. Brazil hosts the world's best for the first time.",
    accent: "#9B59B6",
    accentDim: "rgba(155,89,182,0.12)",
    status: "COMING 2027",
    statusColor: "#9B59B6",
    detail: "32 nations · Brazil 2027 · Coming soon",
    teaser: true,
  },
];

export default function GanniGamesHome() {
  const navigate = useNavigate();
  const { user, displayName, logout } = useAuth();
  const [hovered, setHovered] = useState(null);

  return (
    <div style={{ minHeight: "100vh", background: "var(--navy)" }}>

      {/* ── Header ── */}
      <header style={{
        borderBottom: "1px solid var(--border)",
        background: "linear-gradient(135deg, #060e1d 0%, #0a1628 100%)",
        padding: "0 20px",
      }}>
        <div style={{ maxWidth: 1000, margin: "0 auto", display: "flex", alignItems: "center", justifyContent: "space-between", height: 64 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <img src={spaceNeedle} alt="Ganni Games" style={{ width: 36, height: 36, objectFit: "cover", borderRadius: 8, flexShrink: 0 }} />
            <span style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 26, letterSpacing: 3, color: "white" }}>
              GANNI<span style={{ color: "#FFD700" }}>GAMES</span>
            </span>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            {displayName && (
              <span style={{ fontSize: 13, color: "rgba(255,255,255,0.4)" }} className="hide-mobile">
                {displayName}
              </span>
            )}
            {user ? (
              <>
                <button onClick={() => navigate("/account")} className="btn btn-ghost btn-sm">👤 My Account</button>
                <button onClick={logout} className="btn btn-ghost btn-sm">Sign Out</button>
              </>
            ) : (
              <button onClick={() => navigate("/wc-pool")} className="btn btn-primary btn-sm">Sign In</button>
            )}
          </div>
        </div>
      </header>

      {/* ── Hero ── */}
      <div style={{
        textAlign: "center",
        padding: "64px 20px 48px",
        background: "radial-gradient(ellipse 80% 60% at 50% 0%, rgba(255,215,0,0.06) 0%, transparent 70%)",
      }}>
<h1 style={{
          fontFamily: "'Bebas Neue', sans-serif",
          fontSize: "clamp(36px, 7vw, 72px)",
          lineHeight: 1.05,
          letterSpacing: 3,
          color: "white",
          marginBottom: 16,
          maxWidth: 700,
          margin: "0 auto 16px",
        }}>
          WE LIKE SPORTS AND<br />
          <span style={{ color: "#FFD700" }}>WE DON'T CARE WHO KNOWS!</span>
        </h1>
        <p style={{ fontSize: 16, color: "rgba(255,255,255,0.4)", maxWidth: 480, margin: "0 auto" }}>
          Free-to-play sports pools
        </p>
      </div>

      {/* ── Game Cards ── */}
      <div style={{
        maxWidth: 900,
        margin: "0 auto",
        padding: "0 20px 80px",
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
        gap: 24,
      }}>
        {GAMES.map((g) => {
          const game = { ...g, teaser: g.teaser || (g.adminOnly && user?.uid !== ADMIN_UID) };
          return (
          <div
            key={game.id}
            onClick={() => !game.teaser && navigate(game.route)}
            onMouseEnter={() => !game.teaser && setHovered(game.id)}
            onMouseLeave={() => setHovered(null)}
            style={{
              background: hovered === game.id
                ? "linear-gradient(145deg, #1a2d4a, #1f3555)"
                : "var(--navy-card)",
              border: `1px solid ${hovered === game.id ? game.accent + "55" : "var(--border)"}`,
              borderRadius: 20,
              padding: 28,
              cursor: game.teaser ? "default" : "pointer",
              opacity: game.teaser ? 0.7 : 1,
              transition: "all 0.2s ease",
              transform: hovered === game.id ? "translateY(-4px)" : "none",
              boxShadow: hovered === game.id
                ? `0 16px 48px rgba(0,0,0,0.4), 0 0 0 1px ${game.accent}22`
                : "0 2px 12px rgba(0,0,0,0.3)",
              position: "relative",
              overflow: "hidden",
            }}
          >
            {/* Accent corner glow */}
            <div style={{
              position: "absolute", top: 0, right: 0,
              width: 160, height: 160,
              background: `radial-gradient(circle at top right, ${game.accentDim}, transparent 70%)`,
              pointerEvents: "none",
            }} />

            {/* Top row */}
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 20 }}>
              <div style={{
                width: 56, height: 56, borderRadius: 14,
                background: game.accentDim,
                border: `1px solid ${game.accent}33`,
                display: "flex", alignItems: "center", justifyContent: "center",
                fontSize: 28,
              }}>
                {game.emoji}
              </div>
              <span style={{
                fontSize: 11, fontWeight: 700, letterSpacing: 1.5,
                color: game.statusColor,
                background: `${game.statusColor}18`,
                border: `1px solid ${game.statusColor}44`,
                borderRadius: 100, padding: "4px 10px",
              }}>
                {game.status}
              </span>
            </div>

            {/* Name + tagline */}
            <div style={{ fontSize: 11, fontWeight: 600, letterSpacing: 2, color: game.accent, marginBottom: 6, textTransform: "uppercase" }}>
              {game.tagline}
            </div>
            <div style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 30, letterSpacing: 2, color: "white", marginBottom: 10, lineHeight: 1.1 }}>
              {game.name}
            </div>
            <p style={{ fontSize: 14, color: "rgba(255,255,255,0.5)", lineHeight: 1.6, marginBottom: 20 }}>
              {game.description}
            </p>

            {/* Detail line */}
            <div style={{ fontSize: 12, color: "rgba(255,255,255,0.25)", marginBottom: 20, fontStyle: "italic" }}>
              {game.detail}
            </div>

            {/* CTA */}
            <div style={{
              display: "flex", alignItems: "center", justifyContent: "space-between",
              borderTop: "1px solid var(--border)", paddingTop: 16,
            }}>
              <span style={{ fontSize: 13, fontWeight: 700, color: game.accent }}>
                {game.teaser ? "Coming Soon" : "Play Now →"}
              </span>
              <div style={{
                width: 32, height: 32, borderRadius: "50%",
                background: game.accentDim,
                border: `1px solid ${game.accent}44`,
                display: "flex", alignItems: "center", justifyContent: "center",
                fontSize: 16,
                transform: hovered === game.id ? "scale(1.15)" : "scale(1)",
                transition: "transform 0.2s",
              }}>
                →
              </div>
            </div>
          </div>
          );
        })}
      </div>

      {/* ── Footer ── */}
      <div style={{ borderTop: "1px solid var(--border)", padding: "24px 20px", textAlign: "center" }}>
        <span style={{ fontSize: 12, color: "rgba(255,255,255,0.2)", display: "inline-flex", alignItems: "center", gap: 6 }}>
          <img src={spaceNeedle} alt="" style={{ width: 16, height: 16, objectFit: "cover", borderRadius: 4, opacity: 0.6 }} />
          GanniGames · Free-to-play sports pools
        </span>
      </div>
    </div>
  );
}
